import { render, staticRenderFns } from "./dragFormItem.vue?vue&type=template&id=5626fdeb&scoped=true&"
import script from "./dragFormItem.vue?vue&type=script&lang=js&"
export * from "./dragFormItem.vue?vue&type=script&lang=js&"
import style0 from "./dragFormItem.vue?vue&type=style&index=0&id=5626fdeb&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5626fdeb",
  null
  
)

export default component.exports